import { Modal } from 'almanac-ui/Modal'
import Styles from './MetaAdsAccountSetupModal.module.scss'
import { MetaAdsAccountSetupModalProps } from './Types'
import { Heading } from 'blaze-ui/Heading/Heading'
import MetaBrand from 'blaze-ui/icons/20/MetaBrand'
import { useMetaAdsAccountSetup } from './useMetaAdsAccountSetup'
import { useModals } from 'almanac-ui/Modal/ModalStack'

const Title = ({ text }: { text: string }) => (
  <span className={Styles.modalTitle}>
    <MetaBrand size={32} />
    <Heading level={2}>{text}</Heading>
  </span>
)

export const MetaAdsAccountSetupModal = ({ handleSubmit, ...props }: MetaAdsAccountSetupModalProps) => {
  const { closeModal } = useModals()

  const { Content, isDisabled, title, cancelText, onModalCancel, onModalSubmit } = useMetaAdsAccountSetup({
    ...props,
    handleSubmit: (accounts) => {
      handleSubmit(accounts)
      closeModal()
    },
  })

  return (
    <Modal.Root size="sm" onPressOutside={props.onPressOutside} aria-label="Meta Ads Account Setup" blaze>
      <Modal.Header title={<Title text={title} />} />
      <Modal.Content fillAvailableSpace>{Content}</Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton size="md" variant="tertiary" onPress={onModalCancel}>
            {cancelText}
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton size="lg" isDisabled={isDisabled} onPress={onModalSubmit}>
            Confirm
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
